export const GENERIC_FIELD_DEPRECATION_MESSAGE = 'This field is deprecated. Please remove it along with any associated filters or configurations.';
export const FIELD_DEPRECATION_MESSAGE = 'This field is deprecated, please remove it from your report';
export const CONFIGURATION_DEPRECATION_MESSAGE = 'This configuration is using a deprecated field, please remove it from your report';
